import { render, staticRenderFns } from "./internationalTransfer.vue?vue&type=template&id=228b228c&scoped=true"
import script from "./internationalTransfer.vue?vue&type=script&lang=js"
export * from "./internationalTransfer.vue?vue&type=script&lang=js"
import style0 from "./internationalTransfer.vue?vue&type=style&index=0&id=228b228c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228b228c",
  null
  
)

export default component.exports